import { FC } from 'react';

import { Section, SectionTitle } from './atoms';
import SharingChain from '../SharingChain';
import { CampaignDetail, CampaignSharingChain } from '@/apis/core';

interface ConnectivityChainSectionProps {
  campaign: CampaignDetail;
  sharingChain: CampaignSharingChain;
}

export const ConnectivityChainSection: FC<ConnectivityChainSectionProps> = ({
  campaign,
  sharingChain,
}) => {
  const rulesEngineResults = campaign.rulesEngineResultsJson
    ? JSON.parse(campaign.rulesEngineResultsJson)
    : {};
  const mno = rulesEngineResults.mno || '--';

  return (
    <Section>
      <SectionTitle>Connectivity Chain</SectionTitle>
      <SharingChain excludeTitle carrier={mno} nodes={sharingChain.nodes} />
    </Section>
  );
};

export default ConnectivityChainSection;
